import { Injectable } from '@angular/core';
import { ErrorWithResourceKey } from 'app/shared/errorWithResourceKey';

@Injectable()
export class AuthServiceErrorHandler {
    public static readonly emailAlreadyInUseCode = 'auth/email-already-in-use';
    public static readonly userNotFoundCode = 'auth/user-not-found';
    public static readonly wrongPasswordCode = 'auth/wrong-password';
    public static readonly invalidEmailCode = 'auth/invalid-email';
    public static readonly emailNotVerifiedCode = 'auth/email-not-verified';
    public static readonly requiresRecentLoginCode = 'auth/requires-recent-login';
    public static readonly expiredActionCodeCode = 'auth/expired-action-code';
    public static readonly invalidActionCodeCode = 'auth/invalid-action-code';
    public static readonly userDisabledCode = 'auth/user-disabled';
    public static readonly weakPasswordCode = 'auth/weak-password';

    constructor() { }

    public async handleError(err: any) {
        // Since we are in a promise, we need to do this hack to bubble up the exception
        // Ref. : http://bit.ly/2tRFrg0
        await new Promise(resolve => {
            setTimeout(() => {
                resolve();
                throw this.convertError(err);
            }, 0);
        });
    }

    public convertError(err) {
        let transformedError: Error;

        switch (err.code) {
            case AuthServiceErrorHandler.wrongPasswordCode:
                transformedError = new WrongCredentialsError();
                break;

            case AuthServiceErrorHandler.invalidEmailCode:
                transformedError = new WrongCredentialsError();
                break;

            case AuthServiceErrorHandler.userNotFoundCode:
                transformedError = new UserNotFoundError();
                break;

            case AuthServiceErrorHandler.emailNotVerifiedCode:
                transformedError = new EmailNotVerifiedError();
                break;

            case AuthServiceErrorHandler.emailAlreadyInUseCode:
                transformedError = new EmailAlreadyInUseError();
                break;

            case AuthServiceErrorHandler.requiresRecentLoginCode:
                transformedError = new RecentLoginRequiredError();
                break;

            case AuthServiceErrorHandler.expiredActionCodeCode:
                transformedError = new ExpiredActionCodeError();
                break;

            case AuthServiceErrorHandler.invalidActionCodeCode:
                transformedError = new InvalidActionCodeError();
                break;

            case AuthServiceErrorHandler.userDisabledCode:
                transformedError = new UserDisabledError();
                break;

            case AuthServiceErrorHandler.weakPasswordCode:
                transformedError = new WeakPasswordError();
                break;

            default:
                transformedError = new AuthServiceError(err);
                break;
        }

        return transformedError;
    }
}

export class EmailAlreadyInUseError extends ErrorWithResourceKey {
    constructor() {
        super('EmailAlreadyInUseError', 'Email already in use.', 'Email already in use');
    }
}

export class UserNotFoundError extends ErrorWithResourceKey {
    constructor() {
        super('UserNotFoundError', 'User not found', 'errors.wrong-username-or-password');
    }
}

export class WrongCredentialsError extends ErrorWithResourceKey {
    constructor() {
        super('WrongCredentialsError', 'Wrong username password combination', 'errors.wrong-username-or-password');
    }
}

export class EmailNotVerifiedError extends ErrorWithResourceKey {
    constructor() {
        super('EmailNotVerifiedError', 'This email is not verified.', 'errors.email-not-verified');
    }
}

export class RecentLoginRequiredError extends ErrorWithResourceKey {
    constructor() {
        super('RecentLoginRequiredError', 'This operation requires recent login.', 'errors.requires-recent-login');
    }
}

export class ExpiredActionCodeError extends ErrorWithResourceKey {
    constructor() {
        super('ExpiredActionCode', 'The given action code is either invalid or expired.', 'errors.expired-or-invalid-action-code');
    }
}

export class UserDisabledError extends ErrorWithResourceKey {
    public name = 'UserDisabledError';
    public resourceKey = 'errors.requires-recent-login';
    constructor() {
        super('UserDisabledError', 'This action requires recent login.', 'errors.requires-recent-login');
    }
}

export class InvalidActionCodeError extends ErrorWithResourceKey {
    constructor() {
        super('InvalidActionCode', 'The given action code is either invalid or expired.', 'errors.expired-or-invalid-action-code');
    }
}

export class AuthServiceError extends ErrorWithResourceKey {
    constructor(err: Error) {
        super(err.name, err.message, '');
    }
}

export class WeakPasswordError extends ErrorWithResourceKey {
    constructor() {
        super('WeakPasswordError', 'This password is too weak.', 'errors.weak-password');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/authServiceErrorHandler.ts